import { useContext, useState } from "react"

import CreateCancel from "../../components/forms/CreateCancel"
import Tabel from "../../components/tabel/Tabel";

import DashboardContext from "../../Context"
import FormConsultationRequest from "./FormConsultationRequest";


export default function ConsultationRequest() {
    const { SohwaddFrom, handelFromTabel } = useContext(DashboardContext)

    const [FormTabel, setFormTabel] = useState(false)

    const handelShowForm = () => {
        setFormTabel(!FormTabel)
        handelFromTabel({})
    }

    return (
        <>
            <CreateCancel />
            {
                SohwaddFrom ?
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '15px' }} >

                        { <FormConsultationRequest/>}
                    </div>
                    :
                    <>
                        <Tabel showform FormTabel={FormTabel} handelShowForm={handelShowForm} />
                    </>
            }
        </>
    )
}

